module.exports = __webpack_public_path__ + "static/media/map2.b6b4ad06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/contact/map2.jpg
// module id = 326
// module chunks = 0